import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { IProductGroupAdminCategory } from '@cbgms/api'
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography
} from '@mui/material'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import ToggleOffIcon from '@mui/icons-material/ToggleOff'
import { useTranslation } from 'react-i18next'
import { Alert } from '@carsys/ui'

interface IColumnProps {
  category: IProductGroupAdminCategory
}

const Column: React.FC<IColumnProps> = ({ category }) => {
  const { t } = useTranslation()
  const { tree_uuid } = useParams<{ tree_uuid?: string }>()

  return (
    <Card variant='outlined'>
      <CardHeader
        title={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title={`${category.IsActive ? t('productgroup.active') : t('productgroup.disabled')}`} placement='left' arrow>
              {category.IsActive ? <ToggleOnIcon color='success' /> : <ToggleOffIcon color='error' />}
            </Tooltip>
            <Typography variant='h6' sx={{ ml: 1 }}>
              <Link to={`/product-group/${tree_uuid}/main-group/${category.UUID}`}>{category.Name}</Link>
            </Typography>
          </Box>
        }
      />
      <Divider />

      <CardContent>
        {!category.Categories && (
          <Box sx={{ p: 1 }}>
            <Alert color='muted'>{t('productgroup.alertNoCodes')}</Alert>
          </Box>
        )}
        <List disablePadding dense>
          {category.Categories?.map(subcategory => {
            return (
              <ListItem key={subcategory.UUID} disablePadding data-testid='subcategory'>
                <ListItemButton href={`/product-group/${tree_uuid}/main-group/${category.UUID}/sub-group/${subcategory.UUID}`}>
                  <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                    <Tooltip
                      title={`${subcategory.IsActive ? t('productgroup.active') : t('productgroup.disabled')}`}
                      placement='left'
                      arrow
                    >
                      {subcategory.IsActive ? <ToggleOnIcon color='success' /> : <ToggleOffIcon color='error' />}
                    </Tooltip>
                  </ListItemIcon>
                  <ListItemText primary={subcategory.Name} />
                </ListItemButton>
              </ListItem>
            )
          })}
        </List>
      </CardContent>
    </Card>
  )
}

export default Column
